import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field } from 'redux-form';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Modal } from 'reactstrap';
import { format } from 'date-fns';

// constants
import {
  renderFieldText,
  renderFieldTextarea,
  renderCheckbox,
  renderSelect,
  renderFieldRadio,
  renderFieldCheckbox,
  renderDatePickerWithLabel,
  renderDateTimePickerWithLabel,
  renderHiddenFieldText,
  renderStarRating,
  renderPhoneNumberField,
  renderEmojiRating
} from './base-components';
import {
  LABEL_POSITION_TOP,
  CDN_URL,
  DATE_FORMAT,
  FILE_TYPES,
  DATE_FORMAT_FNS,
  LEAD_FORM_AUDIO_PREFIX
} from '../../constants/constant';
import {
  ALLOWED_FORM_LAYOUTS,
  GROUP_FIELD_TYPE_JSON
} from '../../constants/section-constants/editprofile-constants';
import ImageCropper from './uploader-image-with-cropper';
import AllFilesDropOnly from './uploader-files-only';
import appIcons from '../../constants/appIcons';
import LocalStrings from '../../assets/languages';
import TextWithLink from './TextWithLink';
import Timezone from './timezone';
import { NOT_ALLOWED_FIELDS } from '../../constants/section-constants/editprofile-constants';
import { IMAGE_CROPPER_SIZES } from '../../constants/section-constants/type-constants';
import {
  getEventThemeColors,
  getFileAcceptType,
  getThumbImageUrl,
  isValidDate
} from '../../util/util-common';

// actions
import { updateWorkingForm } from '../myprofile/actions';
import { setLastModifiedFormField } from '../../actions';

// files
import NoImgIcon from '../../assets/img/placeholders/NoImg.svg';

const POPUP_MODAL_ALLOWED_TYPES = {
  group: ['products', 'coupons', 'deals'],
  files: ['image', 'video', 'audio', 'document', 'file']
};

const CheckoutForm = props => {
  const {
    // state
    session,
    deviceSize,
    productCategories,
    productSubCategories,
    eventDetails,

    // props
    isAppCall = false,
    formLayout = ALLOWED_FORM_LAYOUTS.single,
    dynamicForm,
    callsForm,
    isSaving, // bool | denotes if the form has submitted, combines main and secondary loader
    refreshForm,
    workingDynamicForm,
    handlePopupModalSubmit = null,
    popupModal = null,
    setPopupModal = null,
    resetPopup = null, // popupModal + parent form reset
    onChangeManagerProps = null, // Manages conditional form for options based fields (checkbox, dropdowns, radio buttons)
    dynamicInterestRender = null // Edit profile custom interest render function as component
  } = props;

  const profileTypeForm = _.includes(
    ['profile', 'exhibitor', 'sponsor'],
    callsForm
  );
  const ratingTypeForm = _.includes(['survey', 'sessionRating'], callsForm);

  useEffect(() => {
    let workingForm = _.cloneDeep(dynamicForm);

    if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
      _.map(workingForm, (secItem, secItemIndex) => {
        if (secItem?.section_items) {
          _.map(secItem.section_items, (subSecItem, subSecIndex) => {
            let check = [subSecItem];

            if (subSecItem.key === 'file') {
              if (
                check &&
                check.length > 0 &&
                check[0].value &&
                check[0].value.length > 0
              ) {
                let exhistingFileArray = [];
                _.map(check[0].value, fileItem => {
                  const file =
                    typeof fileItem !== 'string' ? fileItem.file : fileItem;

                  if (!_.isEmpty(file)) {
                    let f1 = file.split('/').pop();
                    let f2 = f1.substr(0, f1.lastIndexOf('_'));
                    let ext = f1.split('.').pop();
                    let fileName = f2 + '.' + ext;
                    let fileObj = { file: file, filename: fileName };
                    exhistingFileArray.push(fileObj);
                  }
                });
                subSecItem.fileArray = exhistingFileArray;
              } else {
                subSecItem.fileArray = [];
              }
            } else if (subSecItem.key === 'group') {
              // NOTE: This below approach follows shallow copy. So recordArray update was changing workingForm's value array too.
              // Using deep cloning now to avoid this situation
              let initialPushItem = [
                _.cloneDeep(GROUP_FIELD_TYPE_JSON[subSecItem.type])
              ];

              if (!_.isEmpty(check) && !_.isEmpty(check[0]?.value)) {
                initialPushItem = _.cloneDeep(check[0].value);
              }

              subSecItem.recordArray = initialPushItem;
            }
            workingForm[secItemIndex].section_items[subSecIndex] = subSecItem;
          });
        } else {
          let check = [secItem];
          if (secItem.key === 'file') {
            if (
              check &&
              check.length > 0 &&
              check[0]?.value &&
              check[0]?.value.length > 0
            ) {
              let exhistingFileArray = [];
              _.map(check[0].value, fileItem => {
                const file =
                  typeof fileItem !== 'string' ? fileItem.file : fileItem;

                if (!_.isEmpty(file)) {
                  let f1 = file.split('/').pop();
                  let f2 = f1.substr(0, f1.lastIndexOf('_'));
                  let ext = f1.split('.').pop();
                  let fileName = f2 + '.' + ext;
                  let fileObj = { file: file, filename: fileName };
                  exhistingFileArray.push(fileObj);
                }
              });
              secItem.fileArray = exhistingFileArray;
            } else {
              secItem.fileArray = [];
            }
          }
        }
      });
    } else {
      _.map(workingForm, (item, index) => {
        let check = [item];

        if (item.key === 'file') {
          if (check?.length && check[0]?.value?.length) {
            let exhistingFileArray = [];
            _.map(check[0].value, fileItem => {
              const file =
                typeof fileItem !== 'string' ? fileItem.file : fileItem;

              if (!_.isEmpty(file)) {
                let f1 = file.split('/').pop();
                let f2 = f1.substr(0, f1.lastIndexOf('_'));
                let ext = f1.split('.').pop();
                let fileName = f2 + '.' + ext;
                let fileObj = { file: file, filename: fileName };
                exhistingFileArray.push(fileObj);
              }
            });
            item.fileArray = exhistingFileArray;
          } else {
            item.fileArray = [];
          }
        } else if (item.key === 'group') {
          // NOTE: This below approach follows shallow copy. So recordArray update was changing workingForm's value array too.
          // Using deep cloning now to avoid this situation
          let initialPushItem = [_.cloneDeep(GROUP_FIELD_TYPE_JSON[item.type])];

          if (!_.isEmpty(check) && !_.isEmpty(check[0]?.value)) {
            initialPushItem = _.cloneDeep(check[0].value);
          }

          item.recordArray = initialPushItem;
        }
        workingForm[index] = item;
      });
    }
    props.updateWorkingForm({ form: workingForm });
  }, [refreshForm, dynamicForm]);

  /* ---------------------- Field control section starts ---------------------- */
  const onChangeManager = e => {
    if (onChangeManagerProps) onChangeManagerProps(e);
    props.setLastModifiedFormField(e.target.name);
  };
  /* ----------------------- Field control section ends ----------------------- */

  /* ------------------------ File Field Section Start ------------------------ */
  const onFilesDrop = (data, name) => {
    let local_workingDynamicForm = _.cloneDeep(workingDynamicForm);

    let checkEventFormFile = [];
    if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
      _.map(local_workingDynamicForm.form, formItem => {
        if (formItem?.section_items) {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'file' && secItem.name === name)
              checkEventFormFile.push(secItem);
          });
        } else {
          if (formItem.key === 'file' && formItem.name === name)
            checkEventFormFile.push(formItem);
        }
      });
    } else {
      checkEventFormFile = _.filter(local_workingDynamicForm.form, obj => {
        return obj.key === 'file' && obj.name === name;
      });
    }

    let fileArray = checkEventFormFile[0].fileArray;
    fileArray.push(data);

    props.updateWorkingForm(local_workingDynamicForm);
  };

  const onFileAvailable = available => {
    props.dynamicFieldChanged(available);
  };

  const onFilesRemove = (index, name) => {
    let local_workingDynamicForm = _.cloneDeep(workingDynamicForm);

    let checkEventFormFile = [];
    if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
      _.map(local_workingDynamicForm.form, formItem => {
        if (formItem?.section_items) {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'file' && secItem.name === name)
              checkEventFormFile.push(secItem);
          });
        } else {
          if (formItem.key === 'file' && formItem.name === name)
            checkEventFormFile.push(formItem);
        }
      });
    } else {
      checkEventFormFile = _.filter(local_workingDynamicForm.form, obj => {
        return obj.key === 'file' && obj.name === name;
      });
    }

    let newFileArray = checkEventFormFile[0].fileArray;
    _.pullAt(newFileArray, index);

    props.updateWorkingForm(local_workingDynamicForm);
    props.dynamicFieldChanged(true);
  };

  const _renderFileFields = (accept, name, workingFileType) => {
    let fileArray = [];
    let maxAllowedFilesCount = 1;
    let existingFilesCount = 0;

    if (!_.isEmpty(workingDynamicForm?.form)) {
      let checkEventFormFile = [];
      if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
        _.map(workingDynamicForm.form, formItem => {
          if (formItem?.section_items) {
            _.map(formItem.section_items, secItem => {
              if (secItem.key === 'file' && secItem.name === name)
                checkEventFormFile.push(secItem);
            });
          } else {
            if (formItem.key === 'file' && formItem.name === name)
              checkEventFormFile.push(formItem);
          }
        });
      } else {
        checkEventFormFile = _.filter(workingDynamicForm.form, obj => {
          return obj.key === 'file' && obj.name === name;
        });
      }

      fileArray =
        checkEventFormFile.length > 0 ? checkEventFormFile[0].fileArray : [];
      existingFilesCount = checkEventFormFile.length > 0 ? fileArray.length : 1;

      maxAllowedFilesCount =
        checkEventFormFile.length > 0 ? checkEventFormFile[0].maxupload : 1;
      if (typeof maxAllowedFilesCount === 'string')
        maxAllowedFilesCount = parseInt(maxAllowedFilesCount);
    }

    return (
      <>
        {/* ----- Added file items ----- */}
        {_.map(fileArray, (item, index) => {
          let filePreview = '';
          let fileName = '';
          let fileType = '';
          let fileOld = true;

          if (item && item.file) {
            let file = item.file;
            fileName = item.filename;
            filePreview = `${CDN_URL}${file}`;
            fileOld = true;
            let n = file.search(';base64,');
            if (n > 0) {
              fileOld = false;
              filePreview = item.file;
            }
          }

          if (!fileOld && callsForm !== 'leadscan') return <></>;

          let icon = appIcons.fileDefaultIcon;
          if (!_.isEmpty(fileName)) {
            if (_.isEqual(callsForm, 'leadscan'))
              fileName = fileName.split(LEAD_FORM_AUDIO_PREFIX).pop();
            fileType = fileName.split('.').pop();

            if (_.includes(FILE_TYPES.image, fileType)) {
              icon = fileOld ? `${CDN_URL}${item.file}` : item.file;
            } else if (_.includes([FILE_TYPES.files], fileType)) {
              icon = appIcons.fileDocumentIcon;
            }
            // else icon = appIcons.fileImageIcon;
          }

          return (
            <div key={`key-${fileType}_${index}`} className="col-12">
              <div className={`uploaded-attachment-displaybox`}>
                <div className="row m-0">
                  <div className="col-2 col-sm-2 col-md-1 p-0 text-center">
                    {_.includes(['svg', 'png', 'jpg', 'jpeg'], fileType) ? (
                      <LazyLoadImage
                        className="image-file"
                        alt={'this the available gallery item'}
                        effect="blur"
                        placeholder={
                          <img
                            src={NoImgIcon}
                            className="image-file"
                            alt="lazy load placeholder on error"
                          />
                        }
                        src={icon}
                        onError={e => {
                          e.target.onerror = null;
                          e.target.src = NoImgIcon;
                        }}
                      />
                    ) : (
                      <div className="file-icons">{icon}</div>
                    )}
                  </div>
                  <div className="col-6 col-sm-6 col-md-9 p-0 custom-text1-normal-secondary">
                    <div className="file-name">{fileName}</div>
                  </div>
                  <div
                    className="col-4 col-sm-4 col-md-2 d-flex justify-content-end align-items-center"
                    style={{ gap: '0.5rem' }}
                  >
                    {fileOld && (
                      <a
                        className="action-button"
                        href={filePreview}
                        title="Download"
                        download
                        target="_blank"
                      >
                        <div className="file-icons">
                          {appIcons.downloadIcon}
                        </div>
                      </a>
                    )}

                    <span
                      className="font-icomoon custom-text2-medium-theme cursor-pointer"
                      onClick={() => onFilesRemove(index, name)}
                    >
                      {appIcons.trashIcon}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* ----- File add button ----- */}
        <div className="col-12 form-group">
          <div className="pull-right">
            <button
              type="button"
              className="custom-button-outerline-secondary-md-hover"
              style={{ minWidth: 140 }}
              onClick={() =>
                setPopupModal({
                  state: true,
                  type: workingFileType,
                  name,
                  index: null,
                  mode: accept,
                  fields: null
                })
              }
              disabled={existingFilesCount >= maxAllowedFilesCount}
            >
              {`${LocalStrings.dynamic.kAdd} ${_.startCase(workingFileType)}`}
            </button>
          </div>
        </div>
      </>
    );
  };
  /* ------------------------- File Field Section End ------------------------- */

  /* ------------------------ Group Field Section Start ----------------------- */
  const onProductImageSave = (img, index, name) => {
    let local_workingDynamicForm = _.cloneDeep(workingDynamicForm);

    if (!_.isEmpty(local_workingDynamicForm?.form)) {
      let checkEventFormGroup = [];
      if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
        _.map(local_workingDynamicForm.form, formItem => {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'group' && secItem.name === name)
              checkEventFormGroup.push(secItem);
          });
        });
      } else {
        checkEventFormGroup = _.filter(local_workingDynamicForm.form, obj => {
          return obj.key === 'group' && obj.name === name;
        });
      }

      let newRecordArray = checkEventFormGroup[0].recordArray;
      if (_.isEmpty(newRecordArray[index]))
        newRecordArray[index] = _.cloneDeep(GROUP_FIELD_TYPE_JSON.products);

      newRecordArray[index].productimages = img == '' ? '' : img;
    }

    props.updateWorkingForm(local_workingDynamicForm);
  };

  const onProductImageChange = imageAvailable => {};

  const handleGroupTextField = (e, name, subname, index) => {
    let value = e.target.value;
    let local_workingDynamicForm = _.cloneDeep(workingDynamicForm);

    if (!_.isEmpty(local_workingDynamicForm?.form)) {
      let checkEventFormGroup = [];
      if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
        _.map(local_workingDynamicForm.form, formItem => {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'group' && secItem.name === name)
              checkEventFormGroup.push(secItem);
          });
        });
      } else {
        checkEventFormGroup = _.filter(local_workingDynamicForm.form, obj => {
          return obj.key === 'group' && obj.name === name;
        });
      }

      let newRecordArray = checkEventFormGroup[0].recordArray;
      if (_.isEmpty(newRecordArray[index]))
        newRecordArray[index] = _.cloneDeep(GROUP_FIELD_TYPE_JSON[name]);

      newRecordArray[index][subname] = value;

      if (name === 'products' && subname === 'productcategory') {
        newRecordArray[index].productsubcategory = '';
        props.autofill(`productsubcategory[${index}]`, '');
      }
    }

    props.updateWorkingForm(local_workingDynamicForm);
  };

  const handleGroupDateField = (e, name, subname, index) => {
    let value = format(new Date(e), DATE_FORMAT_FNS);

    let local_workingDynamicForm = _.cloneDeep(workingDynamicForm);

    if (!_.isEmpty(local_workingDynamicForm?.form)) {
      let checkEventFormGroup = [];
      if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
        _.map(local_workingDynamicForm.form, formItem => {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'group' && secItem.name === name)
              checkEventFormGroup.push(secItem);
          });
        });
      } else {
        checkEventFormGroup = _.filter(local_workingDynamicForm.form, obj => {
          return obj.key === 'group' && obj.name === name;
        });
      }

      let newRecordArray = checkEventFormGroup[0].recordArray;
      if (_.isEmpty(newRecordArray[index]))
        newRecordArray[index] = _.cloneDeep(GROUP_FIELD_TYPE_JSON[name]);

      newRecordArray[index][subname] = value;
    }

    props.updateWorkingForm(local_workingDynamicForm);
  };

  const handleGroupArray = (action, index, name) => {
    let local_workingDynamicForm = _.cloneDeep(workingDynamicForm);

    let checkEventFormGroup = [];
    if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
      _.map(local_workingDynamicForm.form, formItem => {
        _.map(formItem.section_items, secItem => {
          if (secItem.key === 'group' && secItem.name === name)
            checkEventFormGroup.push(secItem);
        });
      });
    } else {
      checkEventFormGroup = _.filter(local_workingDynamicForm.form, obj => {
        return obj.key === 'group' && obj.name === name;
      });
    }

    let local_recordArray = checkEventFormGroup[0].recordArray;
    let groupType = checkEventFormGroup[0].type;

    /**
     * NOTE: As per new flow, that groups will be listed in view mode with Edit/Delete option
     * So instead of pushing that new fields into newRecordArray directly using a middle state for modal.
     * When user saves that change form gets submitted, data refreshed
     */

    if (action === 'add') {
      let commonFieldObj = _.cloneDeep(GROUP_FIELD_TYPE_JSON[groupType]);

      setPopupModal({
        state: true,
        type: groupType,
        name,
        index,
        mode: action,
        fields: commonFieldObj
      });
    } else if (action === 'edit') {
      let selectedGroup = _.find(
        local_recordArray,
        (item, itemIndex) => itemIndex == index
      );

      if (!_.isEmpty(selectedGroup)) {
        setPopupModal({
          state: true,
          type: groupType,
          name,
          index,
          mode: action,
          fields: selectedGroup
        });
      }
    } else if (action === 'remove') {
      _.pullAt(local_recordArray, index);

      handlePopupModalSubmit(local_workingDynamicForm);
    }

    props.dynamicFieldChanged(true);
    props.updateWorkingForm(local_workingDynamicForm);
  };

  const _renderGroupFields = (groupType, name) => {
    let recordArray = [];
    let maxEntries = 1;
    let existingEntriesCount = 1;
    let groupfields = [];
    let categories = [];

    if (!_.isEmpty(workingDynamicForm?.form)) {
      let checkEventFormGroup = [];
      if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
        _.map(workingDynamicForm.form, formItem => {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'group' && secItem.name === name)
              checkEventFormGroup.push(secItem);
          });
        });
      } else {
        checkEventFormGroup = _.filter(workingDynamicForm.form, obj => {
          return obj.key === 'group' && obj.name === name;
        });
      }

      if (checkEventFormGroup.length > 0) {
        // Filtering initial blank object of selected group type
        if (
          checkEventFormGroup[0]?.value &&
          !_.isEqual(
            checkEventFormGroup[0].value,
            GROUP_FIELD_TYPE_JSON[groupType]
          )
        ) {
          recordArray = checkEventFormGroup[0].value;
        }
      }

      maxEntries =
        checkEventFormGroup.length > 0 ? checkEventFormGroup[0].maxentries : 1;
      if (typeof maxEntries === 'string') maxEntries = parseInt(maxEntries);
      groupfields =
        checkEventFormGroup.length > 0
          ? checkEventFormGroup[0].groupfields
          : [];
      existingEntriesCount = recordArray.length;
    }

    if (!_.isEmpty(productCategories?.data)) {
      _.map(productCategories.data, (item, index) => {
        categories.push({ value: item.name, text: item.name });
      });
    }

    /**
     * As per new flow, this render will list group fields in a view mode, with create, edit and delete buttons.
     * Upon clicking those popupModal state will manage the form data.
     */

    return (
      <>
        {/* ----- Existing group items list section ----- */}
        {_.map(recordArray, (item, index) => {
          let productImage = '';
          let subcategories = [];

          if (_.isEqual(item, GROUP_FIELD_TYPE_JSON[groupType])) return <></>;

          if (groupType === 'products') {
            let image = item.productimages;
            if (image && image != '') {
              let n = image.search(';base64,');
              if (n > 0) {
                productImage = image;
              } else {
                productImage = `${CDN_URL}${getThumbImageUrl(image, 'sm')}`;
              }
            }
          }

          let categoryName = item?.productcategory ?? '';
          let matchCat = !_.isEmpty(productCategories?.data)
            ? _.find(productCategories?.data, cat => {
                return cat.name == categoryName;
              })
            : {};
          let categoryid = !_.isEmpty(matchCat) ? matchCat?.id : '';

          if (categoryid != '' && !_.isEmpty(productSubCategories?.data)) {
            let matchSubCate = _.filter(productSubCategories.data, sc => {
              return sc.categoryid == categoryid;
            });

            _.map(matchSubCate, (item, index) => {
              subcategories.push({ value: item.name, text: item.name });
            });
          }

          return (
            <div
              key={`${groupType}-key-${index}`}
              className="col-12 col-md-4- p-0 mx-0"
            >
              <div className="row rounded px-0 py-2 mx-0">
                {/* --- Product image --- */}
                <div
                  className={`${
                    groupType !== 'products' ? 'd-none' : 'col-1'
                  } pl-0`}
                >
                  <div className="profile-logo-square-container">
                    <LazyLoadImage
                      alt={'Image'}
                      effect="blur"
                      placeholder={
                        <img
                          src={NoImgIcon}
                          className="logo"
                          alt="lazy load placeholder on error"
                        />
                      }
                      className="profile-logo-square"
                      src={productImage}
                      onError={e => {
                        e.target.onerror = null;
                        e.target.src = NoImgIcon;
                      }}
                    />
                  </div>
                </div>

                {/* --- Group fields details --- */}
                <div
                  className={`col-${
                    groupType !== 'products' ? '11' : '10'
                  } px-0 d-flex flex-column`}
                >
                  {groupType === 'products' ? (
                    <>
                      {/* - Title - */}
                      <span className="custom-text6-medium-primary">
                        {item.producttitle}
                      </span>

                      {/* - Category - Subcategory - */}
                      <span className="custom-text9-medium-primary">
                        {item.productcategory}
                        {!_.isEmpty(item.productsubcategory) ? (
                          <span className="custom-text9-normal-primary">
                            {' - '}
                            {item.productsubcategory}
                          </span>
                        ) : (
                          ''
                        )}
                      </span>

                      {/* - Desc - */}
                      <span className="custom-text10-normal-secondary">
                        <TextWithLink
                          text={item.productinfo}
                          textStyle={'custom-text10-normal-secondary'}
                          maxLines={1}
                          readMore={false}
                        />
                      </span>
                    </>
                  ) : groupType === 'coupons' ? (
                    <>
                      {/* - Title - */}
                      <span className="custom-text6-medium-primary">
                        {item.coupontitle}
                      </span>

                      {/* - Coupon code - */}
                      <span className="custom-text9-medium-primary">
                        {item.couponecode}
                      </span>

                      {/* - Valid till - */}
                      {!_.isEmpty(item.couponvalidtill) &&
                      isValidDate(item.couponvalidtill) ? (
                        <>
                          <span className="custom-text9-medium-primary">
                            <span className="icomoon-font-family">
                              {appIcons.timerIcon}{' '}
                            </span>

                            <Timezone
                              time={item.couponvalidtill}
                              fns_format={'PP'}
                            />
                          </span>
                        </>
                      ) : (
                        ''
                      )}

                      {/* - About - */}
                      <span className="custom-text10-normal-secondary">
                        <TextWithLink
                          textStyle={'custom-text10-normal-secondary'}
                          text={item.couponabout}
                          maxLines={1}
                          readMore={false}
                        />
                      </span>
                    </>
                  ) : groupType === 'deals' ? (
                    <>
                      {/* - Title - */}
                      <span className="custom-text6-medium-primary">
                        {item.dealtitle}
                      </span>

                      {/* - Valid till - */}
                      {!_.isEmpty(item.dealvalidtill) &&
                      isValidDate(item.dealvalidtill) ? (
                        <>
                          <span className="custom-text9-medium-primary">
                            <span className="icomoon-font-family">
                              {appIcons.timerIcon}{' '}
                            </span>

                            <Timezone
                              time={item.dealvalidtill}
                              fns_format={'PP'}
                            />
                          </span>
                        </>
                      ) : (
                        ''
                      )}

                      {/* - About - */}
                      <span className="custom-text10-normal-secondary">
                        <TextWithLink
                          textStyle={'custom-text10-normal-secondary'}
                          text={item.dealabout}
                          maxLines={1}
                          readMore={false}
                        />
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </div>

                {/* --- Edit/Delete buttons --- */}
                <div
                  className="col-1 pr-0 pl-1 d-flex justify-content-end align-items-center"
                  style={{ gap: 4 }}
                >
                  {/* - edit button - */}
                  <div
                    className="dynamic-options-actions-buttons edit"
                    onClick={() => handleGroupArray('edit', index, name)}
                  >
                    <span className="edit-button">{appIcons.notesIcon}</span>
                  </div>

                  {/* - delete button - */}
                  {existingEntriesCount ? (
                    <div
                      className="dynamic-options-actions-buttons"
                      onClick={() => handleGroupArray('remove', index, name)}
                    >
                      <span className="font-icomoon custom-text2-medium-theme">
                        {appIcons.trashIcon}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          );
        })}

        {/* ----- Group field add button ----- */}
        <div className={`col-md-12 px-0`}>
          {existingEntriesCount < maxEntries ? (
            <div className="pull-right">
              <button
                type="button"
                className="custom-button-outerline-secondary-md-hover"
                style={{ minWidth: 140 }}
                onClick={() =>
                  handleGroupArray('add', existingEntriesCount, name)
                }
                disabled={existingEntriesCount >= maxEntries}
              >
                {`${LocalStrings.dynamic.kAdd} ${_.startCase(groupType)}`}
              </button>
            </div>
          ) : (
            ''
          )}
        </div>
      </>
    );
  };
  /* ------------------------- Group Field Section End ------------------------ */

  /* ------------- Popup for group fields / files add/edit starts ------------- */
  const handlePopupModalClose = () => {
    let local_workingDynamicForm = _.cloneDeep(workingDynamicForm);
    if (!_.isEmpty(local_workingDynamicForm?.form)) {
      let checkEventFormGroup = [];
      if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
        _.map(local_workingDynamicForm.form, formItem => {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'group' && secItem.name === popupModal?.name)
              checkEventFormGroup.push(secItem);
          });
        });
      } else {
        checkEventFormGroup = _.filter(local_workingDynamicForm.form, obj => {
          return obj.key === 'group' && obj.name === popupModal?.name;
        });
      }

      if (checkEventFormGroup.length)
        checkEventFormGroup[0].recordArray = checkEventFormGroup[0].value;

      let checkEventFormFile = [];
      if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
        _.map(local_workingDynamicForm.form, formItem => {
          _.map(formItem.section_items, secItem => {
            if (secItem.key === 'file' && secItem.name === popupModal?.name)
              checkEventFormFile.push(secItem);
          });
        });
      } else {
        checkEventFormFile = _.filter(local_workingDynamicForm.form, obj => {
          return obj.key === 'file' && obj.name === popupModal?.name;
        });
      }

      if (checkEventFormFile.length)
        checkEventFormFile[0].recordArray = checkEventFormFile[0].value;
    }

    resetPopup(); // props function from element to reset popupModal and parent form
    props.updateWorkingForm(local_workingDynamicForm);
  };

  const _renderPopupBody = () => {
    const { name, index, type } = popupModal;

    if (_.isEmpty(type)) return <></>;

    let renderType = type;
    if (_.includes(POPUP_MODAL_ALLOWED_TYPES.files, type)) {
      renderType = 'files';
    }

    let recordArray = [];
    let groupfields = [];
    let categories = [];

    if (renderType !== 'files') {
      if (_.isEmpty(popupModal.fields)) return <></>;

      if (!_.isEmpty(workingDynamicForm.form)) {
        let checkEventFormGroup = [];
        if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
          _.map(workingDynamicForm.form, formItem => {
            _.map(formItem.section_items, secItem => {
              if (secItem.key === 'group' && secItem.name === name)
                checkEventFormGroup.push(secItem);
            });
          });
        } else {
          checkEventFormGroup = _.filter(workingDynamicForm.form, obj => {
            return obj.key === 'group' && obj.name === name;
          });
        }

        recordArray =
          checkEventFormGroup.length > 0
            ? checkEventFormGroup[0].recordArray
            : [];
        // maxEntries =
        //   checkEventFormGroup.length > 0
        //     ? checkEventFormGroup[0].maxentries
        //     : 1;
        groupfields =
          checkEventFormGroup.length > 0
            ? checkEventFormGroup[0].groupfields
            : [];
        // existingEntriesCount = recordArray.length;
      }

      if (
        productCategories &&
        productCategories.data &&
        productCategories.data.length > 0
      ) {
        _.map(productCategories.data, (item, index) => {
          categories.push({ value: item.name, text: item.name });
        });
      }
    }

    switch (renderType) {
      case 'products':
        const item = recordArray[index] ?? popupModal.fields;

        let productImage = '';
        let subcategories = [];
        if (type === 'products' && recordArray.length > 0) {
          let image = item.productimages;
          if (image && image != '') {
            let n = image.search(';base64,');
            if (n > 0) {
              productImage = image;
            } else {
              productImage = `${CDN_URL}${getThumbImageUrl(
                image,
                'sm'
              )}?api_key=${session.apiKey}&session_token=${
                session.sessionToken
              }`;
            }
          }
        }

        let categoryName = item.productcategory ?? '';
        let matchCat = _.find(
          productCategories.data,
          cat => cat.name == categoryName
        );
        let categoryid = !_.isEmpty(matchCat) ? matchCat.id : '';

        let subCategorySelected = '';
        if (
          categoryid &&
          !_.isEmpty(productSubCategories) &&
          !_.isEmpty(productSubCategories.data)
        ) {
          let matchSubCate = _.filter(productSubCategories.data, sc => {
            return sc.categoryid == categoryid;
          });

          _.map(matchSubCate, (subCateItem, index) => {
            subcategories.push({
              value: subCateItem.name,
              text: subCateItem.name
            });
          });
        }

        return (
          <>
            <div className="row">
              {/* --- Product image --- */}
              <div className="col-12 col-sm-4 col-md-4 col-lg-3 product-image-section">
                <label className={'control-label-top col-sm-12 p-0'}>
                  {groupfields && groupfields.length > 0
                    ? `${groupfields[0].label}`
                    : ''}
                  <span className="label-mandatory">
                    {`${groupfields[0].required}` === 'true' ? '*' : ''}
                  </span>
                </label>

                <ImageCropper
                  displaySize={IMAGE_CROPPER_SIZES.productImage.display} // For image display style
                  requiredSize={IMAGE_CROPPER_SIZES.productImage.required} // For image size required validation
                  cropperSize={IMAGE_CROPPER_SIZES.productImage.cropper} // Cropper display size. Note its add 50px for padding
                  onImageSave={img => onProductImageSave(img, index, name)}
                  onImageChange={bool => onProductImageChange(bool)}
                  imagepath={productImage}
                  className="drop-zone-area-custom-image"
                  insideText={LocalStrings.dynamic.kUploadPhoto}
                />
              </div>

              {/* --- Product details --- */}
              <div className="col-12 col-sm-8 col-md-8 col-lg-9">
                <div className="row">
                  <div className="col-md-12 mb-1">
                    {/* --- Product name --- */}
                    <Field
                      name={
                        groupfields && groupfields.length > 0
                          ? `${groupfields[3].name}[${index}]`
                          : ''
                      }
                      label={
                        groupfields && groupfields.length > 0
                          ? `${groupfields[3].label}`
                          : ''
                      }
                      placeholder={LocalStrings.dynamic.form_label_title}
                      type="text"
                      component={renderFieldText}
                      mandatory={`${groupfields[3].required}`}
                      maxlength={
                        groupfields && groupfields.length > 0
                          ? groupfields[3].maxlen
                          : ''
                      }
                      onChange={e =>
                        handleGroupTextField(
                          e,
                          name,
                          groupfields[3].name,
                          index
                        )
                      }
                    />
                  </div>

                  {/* --- Product category --- */}
                  <div className="col-md-6 mb-1">
                    <Field
                      name={
                        groupfields && groupfields.length > 0
                          ? `${groupfields[1].name}[${index}]`
                          : ''
                      }
                      label={
                        groupfields && groupfields.length > 0
                          ? groupfields[1].label
                          : ''
                      }
                      supportVal={item?.productcategory}
                      placeholder={LocalStrings.dynamic.kSelectPlaceholder}
                      component={renderSelect}
                      mandatory={`${groupfields[1].required}`}
                      opts={categories}
                      onChange={e =>
                        handleGroupTextField(
                          e,
                          name,
                          groupfields[1].name,
                          index
                        )
                      }
                    />
                  </div>

                  {/* --- Product sub-category --- */}
                  <div className="col-md-6 mb-1">
                    <Field
                      name={
                        groupfields && groupfields.length > 0
                          ? `${groupfields[2].name}[${index}]`
                          : ''
                      }
                      label={
                        groupfields && groupfields.length > 0
                          ? groupfields[2].label
                          : ''
                      }
                      supportVal={item?.productsubcategory}
                      placeholder={LocalStrings.dynamic.kSelectPlaceholder}
                      component={renderSelect}
                      mandatory={`${groupfields[2].required}`}
                      opts={subcategories}
                      onChange={e =>
                        handleGroupTextField(
                          e,
                          name,
                          groupfields[2].name,
                          index
                        )
                      }
                    />
                  </div>

                  {/* --- Product description --- */}
                  <div className="col-md-12 mb-1">
                    <Field
                      name={
                        groupfields && groupfields.length > 0
                          ? `${groupfields[4].name}[${index}]`
                          : ''
                      }
                      label={
                        groupfields && groupfields.length > 0
                          ? groupfields[4].label
                          : ''
                      }
                      placeholder={LocalStrings.dynamic.form_ph_description}
                      component={renderFieldTextarea}
                      mandatory={`${groupfields[4]?.required}`}
                      maxlength={
                        groupfields && groupfields.length > 0
                          ? groupfields[4].maxlen
                          : ''
                      }
                      onChange={e =>
                        handleGroupTextField(
                          e,
                          name,
                          groupfields[4].name,
                          index
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        );

      case 'coupons':
        return (
          <div className="row">
            {/* --- Coupon title --- */}
            <div className="col-md-12 mb-1">
              <Field
                name={
                  groupfields && groupfields.length > 0
                    ? `${groupfields[0].name}[${index}]`
                    : ''
                }
                label={
                  groupfields && groupfields.length > 0
                    ? `${groupfields[0].label}`
                    : ''
                }
                placeholder={LocalStrings.dynamic.form_label_title}
                type="text"
                component={renderFieldText}
                mandatory={`${groupfields[0].required}`}
                maxlength={
                  groupfields && groupfields.length > 0
                    ? groupfields[0].maxlen
                    : ''
                }
                onChange={e =>
                  handleGroupTextField(e, name, groupfields[0].name, index)
                }
              />
            </div>

            {/* --- Coupon desc --- */}
            <div className="col-md-12 mb-1">
              <Field
                name={
                  groupfields && groupfields.length > 0
                    ? `${groupfields[1].name}[${index}]`
                    : ''
                }
                label={
                  groupfields && groupfields.length > 0
                    ? groupfields[1].label
                    : ''
                }
                placeholder={LocalStrings.dynamic.form_ph_description}
                component={renderFieldTextarea}
                mandatory={`${groupfields[1].required}`}
                maxlength={
                  groupfields && groupfields.length > 0
                    ? groupfields[1].maxlen
                    : ''
                }
                onChange={e =>
                  handleGroupTextField(e, name, groupfields[1].name, index)
                }
              />
            </div>

            <div className="col-md-12">
              <div className="row">
                {/* --- Coupon validity --- */}
                <div className="col-md-6 mb-1">
                  <Field
                    name={
                      groupfields && groupfields.length > 0
                        ? `${groupfields[3].name}[${index}]`
                        : ''
                    }
                    label={
                      groupfields && groupfields.length > 0
                        ? groupfields[3].label
                        : ''
                    }
                    component={renderDatePickerWithLabel}
                    mandatory={`${groupfields[3].required}`}
                    onChange={e =>
                      handleGroupDateField(e, name, groupfields[3].name, index)
                    }
                  />
                </div>

                {/* --- Coupon code --- */}
                <div className="col-md-6 mb-1">
                  <Field
                    name={
                      groupfields && groupfields.length > 0
                        ? `${groupfields[2].name}[${index}]`
                        : ''
                    }
                    label={
                      groupfields && groupfields.length > 0
                        ? groupfields[2].label
                        : ''
                    }
                    placeholder={LocalStrings.dynamic.form_label_coupon_code}
                    type="text"
                    component={renderFieldText}
                    mandatory={`${groupfields[2].required}`}
                    maxlength={
                      groupfields && groupfields.length > 0
                        ? groupfields[2].maxlen
                        : ''
                    }
                    onChange={e =>
                      handleGroupTextField(e, name, groupfields[2].name, index)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case 'deals':
        return (
          <div className="row">
            {/* --- Deal name --- */}
            <div className="col-md-12 mb-1">
              <Field
                name={
                  groupfields && groupfields.length > 0
                    ? `${groupfields[0].name}[${index}]`
                    : ''
                }
                label={
                  groupfields && groupfields.length > 0
                    ? `${groupfields[0].label}`
                    : ''
                }
                placeholder={LocalStrings.dynamic.form_label_title}
                type="text"
                component={renderFieldText}
                mandatory={`${groupfields[0].required}`}
                maxlength={
                  groupfields && groupfields.length > 0
                    ? groupfields[0].maxlen
                    : ''
                }
                onChange={e =>
                  handleGroupTextField(e, name, groupfields[0].name, index)
                }
              />
            </div>

            {/* --- Deal description --- */}
            <div className="col-md-12 mb-1">
              <Field
                name={
                  groupfields && groupfields.length > 0
                    ? `${groupfields[1].name}[${index}]`
                    : ''
                }
                label={
                  groupfields && groupfields.length > 0
                    ? groupfields[1].label
                    : ''
                }
                placeholder={LocalStrings.dynamic.form_ph_description}
                component={renderFieldTextarea}
                mandatory={`${groupfields[1].required}`}
                maxlength={
                  groupfields && groupfields.length > 0
                    ? groupfields[1].maxlen
                    : ''
                }
                onChange={e =>
                  handleGroupTextField(e, name, groupfields[1].name, index)
                }
              />
            </div>

            {/* --- Deal validity --- */}
            <div className="col-md-12 mb-1">
              <Field
                name={
                  groupfields && groupfields.length > 0
                    ? `${groupfields[2].name}[${index}]`
                    : ''
                }
                label={
                  groupfields && groupfields.length > 0
                    ? groupfields[2].label
                    : ''
                }
                component={renderDatePickerWithLabel}
                mandatory={`${groupfields[2].required}`}
                onChange={e =>
                  handleGroupDateField(e, name, groupfields[2].name, index)
                }
              />
            </div>
          </div>
        );

      case 'files':
        return (
          <>
            <div className="row h-100">
              <div className="col-md-12">
                <AllFilesDropOnly
                  onFileSave={data => onFilesDrop(data, name)}
                  onFileChangeLocally={bool => onFileAvailable(bool)}
                  accept={getFileAcceptType(popupModal?.type)}
                  className="content-files-dropbox bg-white"
                  insideText={LocalStrings.dynamic.KUploadFiles}
                />
              </div>
            </div>
          </>
        );

      default:
        return <></>;
    }
  };
  /* -------------- Popup for group fields / files add/edit ends -------------- */

  /* ---------------------- Layout wise redux form starts --------------------- */
  const _renderFormFields = customProps => {
    const { form, name, accept, inSection = false } = customProps;
    const dontPutMB = _.includes(['singlecheckbox'], form.key);
    const emptyValue =
      _.isEqual(form.key, 'dynamicfield') &&
      _.isEqual(name, 'interest') &&
      dynamicInterestRender &&
      !_.isEmpty(props?.initialValues?.userinterests)
        ? false
        : !_.isEmpty(form?.value);
    const isFieldReadOnly =
      form?.locked && emptyValue ? true : form?.isreadonly && !session.isadmin;
    const fieldElementClass = `${inSection && !dontPutMB ? 'mb-2' : ''}`;

    return (
      <div className={fieldElementClass}>
        {_.isEqual(form.key, 'textinput') &&
        _.includes(['phonenumber', 'whatsapp'], form.id) ? (
          <Field
            name={name}
            label={form.label}
            component={renderPhoneNumberField}
            mandatory={`${form.required}`}
            labelPosition={LABEL_POSITION_TOP}
            onChange={value => onChangeManager({ target: { name, value } })}
            disabled={isFieldReadOnly}
          />
        ) : _.includes(['textinput', 'numberinput'], form.key) ? (
          <Field
            name={name}
            label={form.label}
            type={form.key == 'textinput' ? 'text' : 'number'}
            component={renderFieldText}
            mandatory={`${form.required}`}
            maxlength={!isFieldReadOnly ? form.maxlen : null}
            labelPosition={LABEL_POSITION_TOP}
            placeholder={form.placeholder ?? ''}
            onChange={onChangeManager}
            disabled={isFieldReadOnly}
          />
        ) : _.isEqual(form.key, 'textarea') ? (
          <Field
            name={name}
            label={form.label}
            component={renderFieldTextarea}
            mandatory={`${form.required}`}
            maxlength={!isFieldReadOnly ? form.maxlen : null}
            labelPosition={LABEL_POSITION_TOP}
            placeholder={form.placeholder ?? ''}
            onChange={onChangeManager}
            disabled={isFieldReadOnly}
          />
        ) : _.isEqual(form.key, 'checkboxes') ? (
          <Field
            name={name}
            label={form.label}
            type="checkbox"
            component={renderCheckbox}
            mandatory={`${form.required}`}
            onChange={val => onChangeManager({ target: { name, value: val } })}
            opts={form.options}
            disabled={isFieldReadOnly}
          />
        ) : _.isEqual(form.key, 'radiobuttons') ? (
          <div className="form-group row">
            <label className="control-label-top col-sm-12">
              {form.label}
              {form.required ? <span className="label-mandatory">*</span> : ''}
            </label>
            <div className="col-sm-12 col-sm-offset-0">
              {_.map(form.options, (opt, index) => {
                const fieldChecked = opt?.value == form?.value ?? false;
                return (
                  <div key={index} style={{ display: 'flex' }}>
                    <Field
                      name={name}
                      label={opt.text}
                      value={opt.value}
                      type="radio"
                      component={renderFieldRadio}
                      onChange={e => onChangeManager(e)}
                      lastOpt={_.isEqual(form.options.length - 1, index)}
                      disabled={isFieldReadOnly}
                      fieldChecked={fieldChecked}
                    />
                  </div>
                );
              })}
              <Field name={form.id} component={renderHiddenFieldText} />
            </div>
          </div>
        ) : _.isEqual(form.key, 'dropdown') ? (
          <Field
            name={name}
            supportVal={form?.value}
            label={form.label}
            placeholder={
              form?.noplaceholder ? '' : LocalStrings.dynamic.kSelectPlaceholder
            }
            component={renderSelect}
            mandatory={`${form.required}`}
            opts={form.options}
            labelPosition={LABEL_POSITION_TOP}
            onChange={e => onChangeManager(e)}
            disabled={isFieldReadOnly}
          />
        ) : _.isEqual(form.key, 'datepicker') ? (
          <Field
            name={name}
            label={form.label}
            component={renderDatePickerWithLabel}
            displayFormat={form?.format ?? 'P'}
            mandatory={`${form.required}`}
            placeholder={form.placeholder ?? ''}
            onChange={val => onChangeManager({ target: { name, value: val } })}
            disabled={isFieldReadOnly}
            isRange={form?.pickertype === 'range'}
            settings={form?.setting || form?.datesetting}
          />
        ) : _.isEqual(form.key, 'datetimepicker') ? (
          <Field
            name={name}
            label={form.label}
            component={renderDateTimePickerWithLabel}
            displayFormat={form?.format ?? 'Pp'}
            mandatory={`${form.required}`}
            placeholder={form.placeholder ?? ''}
            onChange={val => onChangeManager({ target: { name, value: val } })}
            disabled={isFieldReadOnly}
            isRange={form?.pickertype === 'range'}
            settings={form?.setting || form?.datesetting}
          />
        ) : _.isEqual(form.key, 'hyperlink') ? (
          <div className="form-group row">
            <label className="control-label-top col-sm-12">{form.label}</label>
            <a
              href={form.link}
              target="blank"
              className="col-sm-12 col-sm-offset-0 custom-text-color"
            >
              {form.link}
            </a>
          </div>
        ) : _.isEqual(form.key, 'label') ? (
          <label className="custom-text1-medium mb-0">{form.label}</label>
        ) : _.isEqual(form.key, 'paragraph') ? (
          <p className="custom-text1-normal">{form.label}</p>
        ) : _.isEqual(form.key, 'file') ? (
          <div className="row">
            <label className="control-label-top col-sm-12">{form.label}</label>
            {/* {_renderFileFields(accept, name)} */}
            {_renderFileFields(accept, name, form?.filetype)}
          </div>
        ) : _.isEqual(form.key, 'group') ? (
          <div className="form-group row px-3">
            <label className="control-label-top col-sm-12 px-0">
              {form.label}
            </label>

            {_renderGroupFields(form.type, name)}
          </div>
        ) : _.isEqual(form.key, 'singlecheckbox') &&
          _.isEqual(name, 'isnetworking') ? (
          <div className="form-group row mb-0">
            <div className="col-sm-12">
              <Field
                name={name}
                label={form.label}
                component={renderFieldCheckbox}
                value="1"
                type="checkbox"
                onChange={onChangeManager}
                disabled={isFieldReadOnly}
                mandatory={form.required}
              />
            </div>
          </div>
        ) : _.isEqual(form.key, 'rating') ? (
          <Field
            name={name}
            label={form.label}
            component={renderStarRating}
            disabled={isFieldReadOnly}
            mandatory={`${form.required}`}
            labelPosition={LABEL_POSITION_TOP}
            handleChangeRating={props.handleChangeRating}
            color={getEventThemeColors(session, eventDetails)?.selected}
            selectedValue={form.value}
          />
        ) : _.isEqual(form.key, 'emojirating') ? (
          <Field
            name={name}
            label={form.label}
            component={renderEmojiRating}
            disabled={isFieldReadOnly}
            mandatory={`${form.required}`}
            labelPosition={LABEL_POSITION_TOP}
            handleChangeEmojiRating={props.handleChangeEmojiRating}
            emojiValues={props.emojiValues}
          />
        ) : _.isEqual(form.key, 'dynamicfield') &&
          _.isEqual(name, 'interest') &&
          dynamicInterestRender ? (
          dynamicInterestRender(form?.required, isFieldReadOnly)
        ) : (
          ''
        )}
      </div>
    );
  };

  const _renderSinglePageLayout = () => {
    return (
      <>
        {_.map(dynamicForm, (form, index) => {
          // --- Hides field for conditional form flow. Check userDetails reducer action for 'hideForCondition'
          const name = form.name;
          const accept = getFileAcceptType(form?.fileType);

          const show = form?.show ?? true;
          if (
            !show ||
            _.includes(NOT_ALLOWED_FIELDS, name) ||
            form?.hidden ||
            form?.hideForCondition
          )
            return <></>;

          const fieldClass = `${
            profileTypeForm
              ? 'whiteBgBorder10 '
              : ratingTypeForm
              ? 'rating-element '
              : ''
          }p-3 ${!index && form.key === 'section' ? 'mt-0 ' : ''}mb-2`;

          return (
            <div
              key={`singlepage_section${index}`}
              className={fieldClass}
              style={form.key == 'rating' ? { marginBottom: -16 } : {}}
            >
              {form.key === 'section' ? (
                <>
                  <div className="d-flex flex-column w-100 rounded border">
                    {/* --- Section heading --- */}
                    <div className="d-flex flex-column align-items-start mb-2 w-100 px-3 py-1 form-section-heading">
                      <label className="custom-text3-medium-primary mb-0">
                        {form.label}
                      </label>
                      <span className="custom-text9-normal-secondary">
                        {form?.description}
                      </span>
                    </div>

                    {/* --- Section fields --- */}
                    {_.map(form?.section_items, (secItem, secItemKey) => {
                      if (secItem?.hideForCondition || secItem?.hidden) return;
                      const secItemName = secItem.name;
                      const secItemAccept = getFileAcceptType(
                        secItem?.fileType
                      );

                      const showSecItem = secItem?.show ?? true;
                      if (
                        !showSecItem ||
                        _.includes(NOT_ALLOWED_FIELDS, secItemName)
                      )
                        return <></>;

                      return (
                        <div
                          key={`${secItemKey}${secItem.name}`}
                          className="px-3 py-2"
                        >
                          {_renderFormFields({
                            form: secItem,
                            name: secItemName,
                            accept: secItemAccept,
                            inSection: true
                          })}
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div key={`${index}${form.name}`}>
                  {_renderFormFields({ form, name, accept })}
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  };

  const _renderSectionWiseLayout = () => {
    return (
      <>
        {_.map(dynamicForm, (form, index) => {
          // --- Hides field for conditional form flow. Check userDetails reducer action for 'hideForCondition'
          const name = form.name;
          const accept = getFileAcceptType(form?.fileType);

          const show = form?.show ?? true;
          if (
            !show ||
            _.includes(NOT_ALLOWED_FIELDS, name) ||
            form?.hidden ||
            form?.hideForCondition
          )
            return <></>;

          return (
            <div
              key={index}
              className={`${profileTypeForm ? 'whiteBgBorder10' : ''} mb-2`}
              style={form.key == 'rating' ? { marginBottom: -16 } : {}}
            >
              {_renderFormFields({ form, name, accept })}
            </div>
          );
        })}
      </>
    );
  };
  /* ----------------------- Layout wise redux form ends ---------------------- */

  return (
    <>
      {/* === Dynamic form section === */}
      {formLayout === ALLOWED_FORM_LAYOUTS.section
        ? _renderSectionWiseLayout()
        : _renderSinglePageLayout()}

      {/* === Dynamic form group/file field popup === */}
      {!_.isEmpty(popupModal) ? (
        <>
          <Modal
            className={'checkoutform-upload-modal'}
            isOpen={popupModal.state}
            size={
              !_.isEmpty(popupModal.type) &&
              !_.includes(POPUP_MODAL_ALLOWED_TYPES.group, popupModal.type) &&
              !_.includes(POPUP_MODAL_ALLOWED_TYPES.files, popupModal.type)
                ? 'sm'
                : 'lg'
            }
            centered
            keyboard={isSaving}
          >
            {/* ----- Modal header ----- */}
            <div className="heading">
              {/* --- Title section --- */}
              <div className="heading-text custom-text2-medium-primary">
                {/* - Modal type | Add/Edit - */}
                {_.includes(
                  ['products', 'coupons', 'deals'],
                  popupModal.type
                ) ? (
                  <span>
                    {popupModal.mode === 'edit'
                      ? LocalStrings.dynamic.kEdit
                      : LocalStrings.dynamic.kAdd}{' '}
                  </span>
                ) : (
                  ''
                )}

                {/* - Modal type - */}
                <span>
                  {_.includes(['products', 'coupons', 'deals'], popupModal.type)
                    ? _.startCase(popupModal?.name)
                    : `${LocalStrings.dynamic.KUploadFiles}`}
                </span>

                {/* - Index counter (if any) - */}
                <span>
                  {popupModal?.index ? ` #${popupModal?.index + 1} ` : ''}
                </span>
              </div>

              {/* --- Close button --- */}
              <div className="heading-icon">
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={handlePopupModalClose}
                >
                  <span className="font-icomoon custom-text4-medium-primary">
                    {appIcons.crossIcon}
                  </span>
                </button>
              </div>
            </div>

            {/* ----- Modal body ----- */}
            <div className="form-body scrollbar-hide-no-maxheight">
              {popupModal?.errorMessage && (
                <>
                  <div className="row mb-2">
                    <div className="col-12">
                      <span className="text-help">
                        {popupModal?.errorMessage}
                      </span>
                    </div>
                  </div>
                </>
              )}

              {_renderPopupBody()}
            </div>

            {/* ----- Modal footer ----- */}
            <div className="bottom-button-section">
              <button
                type="button"
                className="custom-button-default-md"
                onClick={handlePopupModalClose}
              >
                {LocalStrings.dynamic.kCancel}
              </button>
              <button
                type="button"
                disabled={isSaving}
                className="custom-button-primary-md"
                onClick={() => handlePopupModalSubmit()} // NOTE: sending null is needed, don't modify this syntax
              >
                {isSaving ? (
                  <>
                    <i className={isSaving ? `fa fa-refresh fa-spin` : ''}></i>
                    &ensp;
                  </>
                ) : (
                  ''
                )}
                {LocalStrings.dynamic.kSaveText}
              </button>
            </div>
          </Modal>
        </>
      ) : (
        ''
      )}
    </>
  );
};

const mapStateToProps = state => {
  return {
    session: state.session,
    workingDynamicForm: state.workingDynamicForm,
    deviceSize: state.deviceSize,
    eventDetails: state.eventDetails
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateWorkingForm, setLastModifiedFormField }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
